export default {
  name: 'Modals',
  selector: '.modal-view',
  lazy: true,
  validInnerComponents: [
    'Panel'
  ],
  defaultRules: []
}
